import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { MCButton, MCError, MCText, TabMenu, TextField, ToggleSwitch } from 'src/components/basic';
import PopupSelect from 'src/components/complex/popupSelect';

import { withRouter, lang, remCss } from 'src/helpers';
import { BASE_ICONS } from 'src/components/svg';

import model from '../invitationsModel';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import Bulk, { ImportBtn } from './Bulk';
import constants from 'src/constants';
import mainModel from '../model';
import AlertManager from 'src/components/alert/AlertManager';

class AddManager extends BaseComponent {
  apiStateId = 'invite';
  componentDidMount() {
    model.baseSubscribe(this.subscription);
    model.on('accountSwitched', this.init);
    model.on('profile', this.check);
    this.init();
  }

  check = (profile) => {
    if (profile?.status === constants.general.userStatus.disabled) {
      model.emit('checkDisabledAccount', model.state.user);
      this.back();
    }
  };

  init = () => {
    model.resetApiState('invite');
    model.resetInviteInput();
    this.setTab({ id: 'search' });
  };

  setTab = (tab) => {
    model.resetApiState('invite');
    model.setState({ tab: tab.id });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
    model.cancel('profile', this.check);
  }

  renderInvite = () => {
    const apiStateId = this.apiStateId;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const handleChange = model.handleChange;

    return (
      <>
        <div
          className={'mc-container-content__body-content border'}
          style={{ alignItems: 'center' }}
        >
          <div
            className={'mc-flex-20-col'}
            style={{ width: '100%', maxWidth: remCss(700), marginTop: remCss(10) }}
          >
            <div className={'mc-flex-20'}>
              <TextField
                label={LANG_CONST.fullname}
                placeholder={lang.t(LANG_CONST.text.enter, { attr: lang.t(LANG_CONST.fullname) })}
                value={model.input('fullname')}
                name={'fullname'}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            </div>
            <div className={'mc-flex-20 mc-flex-start'}>
              <TextField
                label={LANG_CONST.email}
                placeholder='uname@mail.com'
                type='email'
                name='email'
                value={model.input('email')}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
              <TextField
                template={6}
                defaultCountryName={model.state.tempCountryAddress}
                name={'phoneNumber'}
                type='phone'
                value={model.input('phoneNumber').toString()}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                label={LANG_CONST.phone_number}
                invalid={invalid}
              />
            </div>
            {invalid?.emailOrPhone && (
              <MCError mcTextProps={{ primary: true }} error={invalid?.emailOrPhone} />
            )}
            <div className={'mc-flex-20'}>{this.renderAccess()}</div>
            {createState.error && (
              <div className={'mc-flex'}>
                <p className='mc-error'>{createState.errorMessage}</p>
              </div>
            )}
          </div>
        </div>
        {this.renderFooter()}
      </>
    );
  };

  renderAccess = () => {
    const createState = model.getApiState(this.apiStateId);

    return (
      <div className={'mc-flex-col'}>
        <MCText label={LANG_CONST.accesses} textLight size={18} />
        {Object.keys(LANG_CONST.constants.manager_access).map((value) => {
          const managerAccess = model.input('managerAccess');
          const list = managerAccess ? managerAccess : [];
          const onChange = () => {
            model.resetApiState(this.apiStateId);
            if (list.includes(value)) {
              model.handleChange(
                'managerAccess',
                list.filter((v) => v !== value)
              );
            } else {
              model.handleChange('managerAccess', [...list, value]);
            }
          };
          return (
            <div className={'mc-flex-20'} key={value}>
              <ToggleSwitch
                disabled={!!this.props.item?.id || createState.loading}
                checked={list?.includes(value)}
                onChange={onChange}
              />
              <div onClick={onChange}>{lang.t(LANG_CONST.constants.manager_access[value])}</div>
            </div>
          );
        })}
      </div>
    );
  };

  renderSearch = () => {
    const apiStateId = this.apiStateId;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;

    return (
      <>
        <div
          className={'mc-container-content__body-content border'}
          style={{ alignItems: 'center' }}
        >
          <div
            className={'mc-flex-20-col'}
            style={{ width: '100%', maxWidth: remCss(450), marginTop: remCss(10) }}
          >
            <div className={'mc-flex-20'}>
              <PopupSelect
                template={6}
                isPopover={true}
                isClearable={false}
                label={lang.t(LANG_CONST.text.select_text, { attr: lang.t(LANG_CONST.user) })}
                placeholder={LANG_CONST.select}
                name={'account'}
                invalid={invalid}
                value={model.state.account?.id}
                initSelectedParamKey={'accountId'}
                apiConfig={{
                  url: 'account/list',
                  labelFn: (user) => <ShortInfo small user={user} specialist={[]} />
                }}
                selectedLabelFn={(user) => (
                  <ShortInfo
                    small
                    user={user}
                    specialist={[]}
                    style={{
                      marginTop: remCss(-3),
                      marginBottom: remCss(-3),
                      cursor: 'pointer'
                    }}
                  />
                )}
                onChange={(n, v, a) => {
                  model.resetApiState(this.apiStateId);
                  model.setState({ account: a.item });
                }}
              />
            </div>
            <div className={'mc-flex-20'}>{this.renderAccess()}</div>
            {createState.error && (
              <div className={'mc-flex'}>
                <p className='mc-error'>{createState.errorMessage}</p>
              </div>
            )}
          </div>
        </div>
        {this.renderFooter()}
      </>
    );
  };

  renderFooter = () => {
    const apiStateId = this.apiStateId;

    const createState = model.getApiState(apiStateId);
    const { loading } = createState;
    return (
      <div className={'mc-container-content__body-footer'}>
        <div className={'mc-flex'}>
          <div className={'mc-grow'}></div>
          <MCButton
            primary
            medium
            light
            radius
            label={LANG_CONST.buttons.cancel}
            to={'/managers'}
            type={'link'}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            loading={loading}
            type={'submit'}
            onClick={(e) => {
              e.preventDefault();
              if (model.state.tab === 'search' && !model.state.account) {
                model.setInvalidApi(this.apiStateId, {
                  length: 1,
                  account: 'User is required.'
                });
              } else {
                model.sendInvite((err, data, success) => {
                  if (success) {
                    this.back();
                    mainModel.setState({ tab: 'invitations' });
                    AlertManager.popup(AlertManager.TYPES.INFO, {
                      close: false,
                      width: 460,
                      title: lang.t(LANG_CONST.notice.sent_invitation, {
                        type: lang.t(LANG_CONST.manager).toLowerCase()
                      }),
                      actionButton: {
                        label: LANG_CONST.buttons.ok,
                        action: (actions) => {
                          actions.hide();
                        }
                      }
                    });
                  }
                });
              }
            }}
            label={LANG_CONST.buttons.send_invite}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex'}>
          <MCButton
            onClick={this.back}
            iconname={BASE_ICONS.BACK_ARROW}
            circle
            primary
            dark
            width={40}
          />
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.add_managers)}</span>
        </div>
        <div className={'mc-container-content__body'}>
          <div
            className={'mc-container-content__body-header mc-add-patient'}
            style={{ margin: remCss(25) }}
          >
            <div>
              <TabMenu
                tabs={[
                  { id: 'search', name: LANG_CONST.search },
                  { id: 'invite', name: LANG_CONST.invite },
                  { id: 'bulk', name: LANG_CONST.bulk }
                ]}
                tab={{ id: model.input('tab') }}
                type={'button'}
                setTab={(v) => {
                  model.resetApiState(this.apiStateId);
                  model.handleChange('tab', v.id);
                }}
              />
            </div>
            <div className={'mc-grow'} />
            {model.state.tab === 'bulk' && <ImportBtn />}
          </div>
          {model.state.tab === 'search' && this.renderSearch()}
          {model.state.tab === 'invite' && this.renderInvite()}
          {model.state.tab === 'bulk' && <Bulk />}
        </div>
      </div>
    );
  }
}

export default withRouter(AddManager);
